module.exports = __webpack_public_path__ + "img/jobsnetwork.8e53010b.svg";